export default {"src":"/_next/static/media/RVTY.3f088461.svg","height":18,"width":18};